export default "__VITE_ASSET__Dx4vjX2c__"